import { Box, CssBaseline } from "@mui/material";
import type { JSX } from "react";
import { Outlet } from "react-router-dom";

import { useUserFeatureNotAvailableDialog } from "@/hooks";

import { UserFeatureNotAvailableDialog } from "../userFeatureNotAvailableDialog";

const AppBaseLayout = (): JSX.Element => {
  const [isUserFeatureNotAvailableDialogOpen, setUserFeatureNotAvailableDialogOpen] =
    useUserFeatureNotAvailableDialog();

  const onCloseUserFeatureNotAvailableDialog = (): void => {
    setUserFeatureNotAvailableDialogOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
        overflowX: "auto",
      }}
    >
      <CssBaseline />
      <Outlet />
      <UserFeatureNotAvailableDialog
        open={isUserFeatureNotAvailableDialogOpen}
        onClose={onCloseUserFeatureNotAvailableDialog}
      />
    </Box>
  );
};

(AppBaseLayout as any).isUnprotected = true; // eslint-disable-line @typescript-eslint/no-explicit-any

export default AppBaseLayout;
